import DummyBanner from './DummyBanner';
export default DummyBanner;